import React, { useEffect, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneRosterClass } from '../../../store/OneRoster/OneRosterClassAction';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import StatusCode from '../../../util/StatusCode';
import RenderTabs from '../../misc/Tabs';
import * as Tab from '../../../util/TabValue';
import OneRosterClassInfo from './OneRosterClassInfo';
import { RequestState } from '../../../models/RequestState';
import NotFound from '../../administration/components/NotFound';
import { useTranslation } from 'react-i18next';
import { OneRosterClass } from '../../../models/CoreOneRosterModels';
import OneRosterClassMembers from './OneRosterClassMembers';
import Loading from '../../misc/Loading';
import OneRosterClassSources from './OneRosterClassSources';
import { RootState } from '../../../store/store';


const OneRosterClassView = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { eventId } = useParams();
    const dispatch = useDispatch();
    const classInfo = useSelector<RootState, RequestState<OneRosterClass>>(state => state.onerosterClass.classInfo);

    useEffect(() => {
        if (eventId !== undefined) {
            getOneRosterClass(eventId)(dispatch);
        }
    }, [dispatch, eventId]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.Members,
        Tab.Tabs.Trackings
    ];

    if (eventId === undefined) {
        return;
    };

    const renderContent = (body: any) => (
        <div className="padding-40 container single">
            <h1><Link to="/oneroster/class">{t('object.oneRoster.section', { ns: 'common', count: 1 })}</Link> {displayName}</h1>
            {body}
        </div>
    )

    let displayName: string | undefined = '';

    switch (classInfo.code) {
        case StatusCode.COMPLETE:
            displayName = classInfo.data.title;
            return (renderContent(<>
                <RenderTabs
                    tabs={tabs}
                    id={eventId}
                    url="oneroster/class" />

                <Suspense>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<OneRosterClassInfo />} />
                        <Route path={Tab.Tabs.Members.url} element={<OneRosterClassMembers />} />
                        <Route path={Tab.Tabs.Trackings.url} element={<OneRosterClassSources />} />
                        <Route path="*" element={<Navigate replace={true} to={`/oneroster/class/${eventId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>));
        case StatusCode.ERROR:
            if (classInfo.error.response?.status === 404 || classInfo.error.response?.status === 400) {
                return <NotFound
                    header={t('object.oneRoster.section', { ns: 'common', count: 1 })}
                    translateKey={{ i18nKey: "notFound.section", ns: "oneRoster" }}
                    link="/oneroster/class"
                />
            } else {
                return renderContent(<p>{classInfo.error.response?.statusText}</p>);
            }
        default:
            return (renderContent(<Loading />));
    }
}

export default OneRosterClassView;
